export default __webpack_public_path__ + "static/media/logo-ultracar-white.c3348999.png";